import React, { useEffect, useState } from 'react';
import { supabase } from '../supabase';

export default function Home({ session, onSelectBoard }: { session: any; onSelectBoard: (board: any, workspace: any) => void }) {
  const [workspaces, setWorkspaces] = useState<any[]>([]);
  const [boards, setBoards] = useState<any[]>([]);
  const [cards, setCards] = useState<any[]>([]);
  const [clients, setClients] = useState<any[]>([]);
  const [memberName, setMemberName] = useState<string>('');
  const [loading, setLoading] = useState(true);
  const [activeFilter, setActiveFilter] = useState<string | null>(null);
  const [activeWorkspaceFilter, setActiveWorkspaceFilter] = useState<string>('all');
  const [time, setTime] = useState(new Date());

  useEffect(() => { fetchAll(); }, []); // eslint-disable-line
  useEffect(() => { const t = setInterval(() => setTime(new Date()), 60000); return () => clearInterval(t); }, []);

  const fetchAll = async () => {
    setLoading(true);
    const { data: ws } = await supabase.from('workspaces').select('*').order('created_at');
    const { data: bd } = await supabase.from('boards').select('*').order('created_at');
    const { data: cd } = await supabase.from('cards').select('*');
    const { data: cl } = await supabase.from('clients').select('*').order('name');
    const { data: profile } = await supabase.from('user_profiles').select('member_name').eq('email', session.user.email).single();
    setWorkspaces(ws || []);
    setBoards(bd || []);
    setCards((cd || []).filter((c: any) => !c.archived));
    setClients(cl || []);
    setMemberName(profile?.member_name || '');
    setLoading(false);
  };

  const handleLogout = async () => { await supabase.auth.signOut(); };

  // FIX TIMEZONE
  const isOverdue = (due_date: string) => {
    if (!due_date) return false;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const due = new Date(due_date + 'T00:00:00');
    return due < today;
  };

  const isToday = (due_date: string) => {
    if (!due_date) return false;
    const today = new Date();
    const due = new Date(due_date + 'T00:00:00');
    return due.getFullYear() === today.getFullYear() &&
      due.getMonth() === today.getMonth() &&
      due.getDate() === today.getDate();
  };

  // Cards do membro logado
  const myCards = memberName
    ? cards.filter(c => (c.members || []).includes(memberName) && c.column_name !== 'done')
    : [];

  const myOverdue = myCards.filter(c => isOverdue(c.due_date));
  const myToday = myCards.filter(c => isToday(c.due_date) && !isOverdue(c.due_date));
  const myTodo = myCards.filter(c => !isOverdue(c.due_date) && !isToday(c.due_date) && c.column_name === 'todo');
  const myOthers = myCards.filter(c => !isOverdue(c.due_date) && !isToday(c.due_date) && c.column_name !== 'todo');

  const backlogCards = cards.filter(c => c.column_name === 'backlog').length;
  const todoCards = cards.filter(c => c.column_name === 'todo').length;
  const wipCards = cards.filter(c => c.column_name === 'wip').length;
  const waitCards = cards.filter(c => c.column_name === 'wait' || c.column_name === 'block').length;
  const doneCards = cards.filter(c => c.column_name === 'done').length;
  const overdueCards = cards.filter(c => isOverdue(c.due_date) && c.column_name !== 'done').length;
  const totalCards = cards.length;

  const getWorkspaceForBoard = (boardId: string) => {
    const board = boards.find(b => b.id === boardId);
    return workspaces.find(w => w.id === board?.workspace_id);
  };

  const getClient = (clientId: string) => clients.find(c => c.id === clientId);

  const filteredCards = () => {
    let filtered = cards;
    if (activeFilter === 'backlog') filtered = cards.filter(c => c.column_name === 'backlog');
    if (activeFilter === 'todo') filtered = cards.filter(c => c.column_name === 'todo');
    if (activeFilter === 'wip') filtered = cards.filter(c => c.column_name === 'wip');
    if (activeFilter === 'wait') filtered = cards.filter(c => c.column_name === 'wait' || c.column_name === 'block');
    if (activeFilter === 'done') filtered = cards.filter(c => c.column_name === 'done');
    if (activeFilter === 'overdue') filtered = cards.filter(c => isOverdue(c.due_date) && c.column_name !== 'done');
    if (activeWorkspaceFilter !== 'all') {
      const workspaceBoards = boards.filter(b => b.workspace_id === activeWorkspaceFilter).map(b => b.id);
      filtered = filtered.filter(c => workspaceBoards.includes(c.board_id));
    }
    return filtered;
  };

  const workspaceIcons: any = { crm: '🗂️', onboarding: '🚀', demandas: '⚡' };
  const workspaceColors: any = { crm: '#8b5cf6', onboarding: '#F5A800', demandas: '#10b981' };
  const teamColors: any = { MANHATTAN: '#F5A800', BROOKLYN: '#6366f1' };

  const greeting = () => {
    const h = time.getHours();
    if (h < 12) return 'Bom dia';
    if (h < 18) return 'Boa tarde';
    return 'Boa noite';
  };

  const displayName = memberName || session.user.email.split('@')[0].split('.')[0];
  const cap = (s: string) => s.charAt(0).toUpperCase() + s.slice(1);
  const formattedDate = time.toLocaleDateString('pt-BR', { weekday: 'long', day: 'numeric', month: 'long' });
  const overallPct = totalCards > 0 ? Math.round(doneCards / totalCards * 100) : 0;

  const stats = [
    { key: 'backlog', label: 'Backlog', value: backlogCards, color: '#94a3b8' },
    { key: 'todo', label: 'Para fazer', value: todoCards, color: '#60a5fa' },
    { key: 'wip', label: 'Em andamento', value: wipCards, color: '#F5A800' },
    { key: 'wait', label: 'Aguardando', value: waitCards, color: '#a78bfa' },
    { key: 'done', label: 'Concluídos', value: doneCards, color: '#34d399' },
    { key: 'overdue', label: 'Atrasados', value: overdueCards, color: '#f87171' },
  ];

  const glassCard: any = {
    background: 'rgba(255,255,255,0.06)',
    backdropFilter: 'blur(24px)',
    WebkitBackdropFilter: 'blur(24px)',
    border: '1px solid rgba(255,255,255,0.1)',
    boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
  };

  const renderTaskCard = (card: any, type: 'overdue' | 'today' | 'todo' | 'other') => {
    const client = getClient(card.client_id);
    const ws = getWorkspaceForBoard(card.board_id);
    const bg = type === 'overdue' ? 'rgba(239,68,68,0.08)' : type === 'today' ? 'rgba(245,168,0,0.06)' : 'rgba(255,255,255,0.03)';
    const border = type === 'overdue' ? 'rgba(239,68,68,0.2)' : type === 'today' ? 'rgba(245,168,0,0.15)' : 'rgba(255,255,255,0.06)';
    const dotColor = type === 'overdue' ? '#f87171' : type === 'today' ? '#F5A800' : '#60a5fa';
    const daysLate = type === 'overdue' && card.due_date ? Math.ceil((new Date().getTime() - new Date(card.due_date + 'T00:00:00').getTime()) / (1000 * 60 * 60 * 24)) : 0;

    return (
      <div key={card.id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 12px', borderRadius: 10, marginBottom: 6, background: bg, border: `1px solid ${border}` }}>
        <div style={{ width: 7, height: 7, borderRadius: '50%', background: dotColor, flexShrink: 0 }} />
        <div style={{ flex: 1, fontSize: 12, color: 'rgba(255,255,255,0.82)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{card.title}</div>
        {client && <span style={{ fontSize: 9, fontWeight: 700, padding: '2px 7px', borderRadius: 20, background: `${teamColors[client.team]}18`, color: teamColors[client.team], flexShrink: 0 }}>{client.team}</span>}
        {client && <span style={{ fontSize: 10, color: 'rgba(255,255,255,0.3)', flexShrink: 0 }}>{client.name}</span>}
        {ws && <span style={{ fontSize: 9, padding: '2px 7px', borderRadius: 20, background: `${workspaceColors[ws.type]}20`, color: workspaceColors[ws.type], flexShrink: 0 }}>{workspaceIcons[ws.type]}</span>}
        {type === 'overdue' && <span style={{ fontSize: 9, fontWeight: 700, padding: '2px 7px', borderRadius: 20, background: 'rgba(239,68,68,0.2)', color: '#f87171', flexShrink: 0 }}>{daysLate}d atraso</span>}
        {type === 'today' && <span style={{ fontSize: 9, fontWeight: 700, padding: '2px 7px', borderRadius: 20, background: 'rgba(245,168,0,0.2)', color: '#F5A800', flexShrink: 0 }}>vence hoje</span>}
      </div>
    );
  };

  return (
    <div style={{ minHeight: '100vh', fontFamily: "'Plus Jakarta Sans', sans-serif", position: 'relative', overflow: 'hidden' }}>

      {/* FUNDO */}
      <div style={{ position: 'fixed', inset: 0, zIndex: 0, backgroundImage: "url('/Empire ADS - Capa Facebook.png')", backgroundSize: 'cover', backgroundPosition: 'center', filter: 'blur(3px) brightness(0.45)', transform: 'scale(1.05)' }} />
      <div style={{ position: 'fixed', inset: 0, zIndex: 0, background: 'rgba(0,0,0,0.6)' }} />

      {/* TOPBAR */}
      <div style={{ position: 'sticky', top: 0, zIndex: 100, background: 'rgba(0,0,0,0.4)', backdropFilter: 'blur(20px)', WebkitBackdropFilter: 'blur(20px)', borderBottom: '1px solid rgba(255,255,255,0.08)', padding: '0 48px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: 64 }}>
        <img src="/Logo-Final-Branco.png" alt="Empire Ads" style={{ height: 38, objectFit: 'contain' }} />
        <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
          <span style={{ fontSize: 12, color: 'rgba(255,255,255,0.4)', textTransform: 'capitalize' }}>{formattedDate}</span>
          <div style={{ width: 1, height: 18, background: 'rgba(255,255,255,0.12)' }} />
          <span style={{ fontSize: 12, color: 'rgba(255,255,255,0.4)' }}>{session.user.email}</span>
          <button onClick={handleLogout} style={{ background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.12)', borderRadius: 8, padding: '6px 16px', color: 'rgba(255,255,255,0.6)', fontSize: 12, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>Sair</button>
        </div>
      </div>

      {/* CONTEÚDO */}
      <div style={{ position: 'relative', zIndex: 1, maxWidth: 1280, margin: '0 auto', padding: '52px 48px' }}>

        {/* HERO */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr auto', gap: 32, marginBottom: 40, alignItems: 'center' }}>
          <div>
            <div style={{ fontSize: 11, fontWeight: 600, color: 'rgba(255,255,255,0.35)', letterSpacing: 2, textTransform: 'uppercase', marginBottom: 10 }}>{formattedDate}</div>
            <h1 style={{ fontSize: 50, fontWeight: 800, color: '#fff', letterSpacing: -2, lineHeight: 1.1, margin: 0, marginBottom: 10 }}>
              {greeting()}, {cap(displayName)}.
            </h1>
            <p style={{ fontSize: 15, color: 'rgba(255,255,255,0.45)', margin: 0 }}>
              {myCards.length > 0 ? (
                <>Você tem <strong style={{ color: '#F5A800' }}>{myCards.length} demanda{myCards.length !== 1 ? 's' : ''}</strong> para hoje{myOverdue.length > 0 ? <> · <strong style={{ color: '#f87171' }}>{myOverdue.length} atrasada{myOverdue.length !== 1 ? 's' : ''}</strong></> : ''}</>
              ) : (
                <>Aqui está o panorama da sua operação hoje</>
              )}
            </p>
          </div>

          {/* PROGRESSO */}
          <div style={{ ...glassCard, borderRadius: 20, padding: '24px 32px', textAlign: 'center', minWidth: 190 }}>
            <div style={{ position: 'relative', width: 80, height: 80, margin: '0 auto 12px' }}>
              <svg width="80" height="80" viewBox="0 0 80 80" style={{ transform: 'rotate(-90deg)' }}>
                <circle cx="40" cy="40" r="32" fill="none" stroke="rgba(255,255,255,0.08)" strokeWidth="5" />
                <circle cx="40" cy="40" r="32" fill="none" stroke="#F5A800" strokeWidth="5"
                  strokeDasharray={`${2 * Math.PI * 32}`}
                  strokeDashoffset={`${2 * Math.PI * 32 * (1 - overallPct / 100)}`}
                  strokeLinecap="round" style={{ transition: 'stroke-dashoffset 0.6s ease' }}
                />
              </svg>
              <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <span style={{ fontSize: 18, fontWeight: 800, color: '#fff' }}>{overallPct}%</span>
              </div>
            </div>
            <div style={{ fontSize: 12, fontWeight: 700, color: 'rgba(255,255,255,0.8)' }}>Progresso geral</div>
            <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.35)', marginTop: 3 }}>{doneCards} de {totalCards} concluídos</div>
          </div>
        </div>

        {/* MEU DIA */}
        {memberName && myCards.length > 0 && (
          <div style={{ marginBottom: 40 }}>
            <div style={{ fontSize: 10, fontWeight: 700, color: 'rgba(255,255,255,0.3)', letterSpacing: 2, textTransform: 'uppercase', marginBottom: 16 }}>Meu dia</div>
            <div style={{ ...glassCard, borderRadius: 18, padding: '22px 24px' }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 18 }}>
                <div style={{ fontSize: 15, fontWeight: 700, color: '#fff' }}>Suas demandas de hoje</div>
                <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.35)', background: 'rgba(255,255,255,0.06)', padding: '3px 12px', borderRadius: 20 }}>{myCards.length} demandas</div>
              </div>

              {myOverdue.length > 0 && (
                <>
                  <div style={{ fontSize: 9, fontWeight: 700, color: '#f87171', letterSpacing: 1.5, textTransform: 'uppercase', padding: '5px 0', borderTop: '1px solid rgba(239,68,68,0.15)', marginBottom: 8 }}>Atrasadas · resolver primeiro</div>
                  {myOverdue.map(c => renderTaskCard(c, 'overdue'))}
                </>
              )}

              {myToday.length > 0 && (
                <>
                  <div style={{ fontSize: 9, fontWeight: 700, color: '#F5A800', letterSpacing: 1.5, textTransform: 'uppercase', padding: '5px 0', borderTop: '1px solid rgba(245,168,0,0.15)', marginBottom: 8, marginTop: myOverdue.length > 0 ? 12 : 0 }}>Vencem hoje</div>
                  {myToday.map(c => renderTaskCard(c, 'today'))}
                </>
              )}

              {myTodo.length > 0 && (
                <>
                  <div style={{ fontSize: 9, fontWeight: 700, color: '#60a5fa', letterSpacing: 1.5, textTransform: 'uppercase', padding: '5px 0', borderTop: '1px solid rgba(96,165,250,0.15)', marginBottom: 8, marginTop: (myOverdue.length > 0 || myToday.length > 0) ? 12 : 0 }}>Para fazer</div>
                  {myTodo.map(c => renderTaskCard(c, 'todo'))}
                </>
              )}

              {myOthers.length > 0 && (
                <>
                  <div style={{ fontSize: 9, fontWeight: 700, color: 'rgba(255,255,255,0.25)', letterSpacing: 1.5, textTransform: 'uppercase', padding: '5px 0', borderTop: '1px solid rgba(255,255,255,0.06)', marginBottom: 8, marginTop: 12 }}>Em andamento</div>
                  {myOthers.map(c => renderTaskCard(c, 'other'))}
                </>
              )}
            </div>
          </div>
        )}

        {/* STATS */}
        <div style={{ fontSize: 10, fontWeight: 700, color: 'rgba(255,255,255,0.3)', letterSpacing: 2, textTransform: 'uppercase', marginBottom: 14 }}>Visão geral da operação</div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(6, 1fr)', gap: 10, marginBottom: 40 }}>
          {stats.map(s => {
            const active = activeFilter === s.key;
            return (
              <div key={s.key} onClick={() => setActiveFilter(active ? null : s.key)} style={{ background: active ? `${s.color}25` : 'rgba(255,255,255,0.06)', backdropFilter: 'blur(20px)', WebkitBackdropFilter: 'blur(20px)', border: `1px solid ${active ? s.color : 'rgba(255,255,255,0.09)'}`, borderRadius: 14, padding: '18px 16px', cursor: 'pointer', transition: 'all 0.2s', boxShadow: active ? `0 8px 32px ${s.color}30` : 'none', transform: active ? 'translateY(-3px)' : 'none', position: 'relative', overflow: 'hidden' }}>
                <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: 2, background: s.color, opacity: active ? 1 : 0.6 }} />
                <div style={{ fontSize: 34, fontWeight: 800, color: s.color, letterSpacing: -1.5, lineHeight: 1, marginBottom: 6 }}>{s.value}</div>
                <div style={{ fontSize: 11, fontWeight: 600, color: 'rgba(255,255,255,0.7)' }}>{s.label}</div>
              </div>
            );
          })}
        </div>

        {/* PAINEL FILTRADO */}
        {activeFilter && (
          <div style={{ ...glassCard, borderRadius: 18, padding: '24px', marginBottom: 40 }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 18 }}>
              <div>
                <div style={{ fontSize: 16, fontWeight: 800, color: '#fff' }}>{stats.find(s => s.key === activeFilter)?.label}</div>
                <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.35)', marginTop: 2 }}>{filteredCards().length} demandas</div>
              </div>
              <div style={{ display: 'flex', gap: 6 }}>
                <button onClick={() => setActiveWorkspaceFilter('all')} style={{ padding: '5px 14px', borderRadius: 100, fontSize: 11, fontWeight: 700, cursor: 'pointer', border: 'none', background: activeWorkspaceFilter === 'all' ? 'rgba(255,255,255,0.9)' : 'rgba(255,255,255,0.1)', color: activeWorkspaceFilter === 'all' ? '#111' : 'rgba(255,255,255,0.6)', fontFamily: 'inherit' }}>Todas</button>
                {workspaces.map(w => (
                  <button key={w.id} onClick={() => setActiveWorkspaceFilter(activeWorkspaceFilter === w.id ? 'all' : w.id)} style={{ padding: '5px 14px', borderRadius: 100, fontSize: 11, fontWeight: 700, cursor: 'pointer', border: 'none', background: activeWorkspaceFilter === w.id ? workspaceColors[w.type] : 'rgba(255,255,255,0.1)', color: activeWorkspaceFilter === w.id ? '#fff' : 'rgba(255,255,255,0.6)', fontFamily: 'inherit' }}>
                    {workspaceIcons[w.type]} {w.name}
                  </button>
                ))}
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
              {filteredCards().length === 0 && <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.35)', textAlign: 'center', padding: '24px 0' }}>Nenhuma demanda encontrada</div>}
              {filteredCards().slice(0, 10).map((card: any) => {
                const ws = getWorkspaceForBoard(card.board_id);
                const overdue = isOverdue(card.due_date) && card.column_name !== 'done';
                const wsColor = workspaceColors[ws?.type] || '#fff';
                return (
                  <div key={card.id} style={{ display: 'flex', alignItems: 'center', gap: 14, padding: '11px 14px', background: overdue ? 'rgba(239,68,68,0.1)' : 'rgba(255,255,255,0.04)', borderRadius: 10, border: `1px solid ${overdue ? 'rgba(239,68,68,0.25)' : 'rgba(255,255,255,0.07)'}`, borderLeft: `3px solid ${overdue ? '#f87171' : wsColor}` }}>
                    <div style={{ flex: 1, fontSize: 13, fontWeight: 600, color: 'rgba(255,255,255,0.82)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{card.title}</div>
                    {ws && <span style={{ fontSize: 10, fontWeight: 700, padding: '2px 8px', borderRadius: 20, background: `${wsColor}20`, color: wsColor, flexShrink: 0 }}>{ws.name}</span>}
                    {card.due_date && <span style={{ fontSize: 11, color: overdue ? '#f87171' : 'rgba(255,255,255,0.3)', flexShrink: 0 }}>{overdue ? '⚠️ ' : ''}{new Date(card.due_date + 'T00:00:00').toLocaleDateString('pt-BR')}</span>}
                    <span style={{ fontSize: 10, fontWeight: 700, padding: '2px 8px', borderRadius: 20, background: 'rgba(255,255,255,0.08)', color: 'rgba(255,255,255,0.4)', flexShrink: 0, textTransform: 'uppercase' }}>{card.column_name}</span>
                  </div>
                );
              })}
              {filteredCards().length > 10 && <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.3)', textAlign: 'center', padding: '8px 0' }}>+ {filteredCards().length - 10} demandas</div>}
            </div>
          </div>
        )}

        {/* ESPAÇOS DE TRABALHO */}
        <div style={{ fontSize: 10, fontWeight: 700, color: 'rgba(255,255,255,0.3)', letterSpacing: 2, textTransform: 'uppercase', marginBottom: 16 }}>Espaços de trabalho</div>
        {loading ? (
          <div style={{ color: 'rgba(255,255,255,0.35)', textAlign: 'center', padding: '48px 0' }}>Carregando...</div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {workspaces.map(ws => {
              const wsBoards = boards.filter(b => b.workspace_id === ws.id);
              const wsCards = cards.filter(c => wsBoards.map(b => b.id).includes(c.board_id));
              const wsColor = workspaceColors[ws.type] || '#fff';
              const wsDone = wsCards.filter(c => c.column_name === 'done').length;
              const wsWip = wsCards.filter(c => c.column_name === 'wip').length;
              const wsOverdue = wsCards.filter(c => isOverdue(c.due_date) && c.column_name !== 'done').length;
              const pct = wsCards.length > 0 ? Math.round(wsDone / wsCards.length * 100) : 0;

              return (
                <div key={ws.id} style={{ ...glassCard, borderRadius: 18, overflow: 'hidden' }}>
                  <div style={{ padding: '20px 26px', display: 'flex', alignItems: 'center', gap: 18 }}>
                    <div style={{ width: 46, height: 46, borderRadius: 12, background: `${wsColor}18`, border: `1px solid ${wsColor}25`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22, flexShrink: 0 }}>{workspaceIcons[ws.type]}</div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontSize: 14, fontWeight: 700, color: '#fff', marginBottom: 7 }}>{ws.name}</div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                        <div style={{ flex: 1, height: 4, background: 'rgba(255,255,255,0.08)', borderRadius: 2, overflow: 'hidden', maxWidth: 240 }}>
                          <div style={{ height: '100%', background: `linear-gradient(90deg, ${wsColor}, ${wsColor}99)`, width: `${pct}%`, borderRadius: 2, transition: 'width 0.5s' }} />
                        </div>
                        <span style={{ fontSize: 11, color: 'rgba(255,255,255,0.35)', fontWeight: 600 }}>{pct}%</span>
                      </div>
                    </div>
                    <div style={{ display: 'flex', gap: 20, alignItems: 'center', flexShrink: 0 }}>
                      <div style={{ textAlign: 'center' }}>
                        <div style={{ fontSize: 18, fontWeight: 800, color: '#fff', lineHeight: 1 }}>{wsCards.length}</div>
                        <div style={{ fontSize: 9, color: 'rgba(255,255,255,0.3)', marginTop: 2 }}>total</div>
                      </div>
                      <div style={{ width: 1, height: 24, background: 'rgba(255,255,255,0.08)' }} />
                      <div style={{ textAlign: 'center' }}>
                        <div style={{ fontSize: 18, fontWeight: 800, color: '#F5A800', lineHeight: 1 }}>{wsWip}</div>
                        <div style={{ fontSize: 9, color: 'rgba(255,255,255,0.3)', marginTop: 2 }}>andamento</div>
                      </div>
                      <div style={{ width: 1, height: 24, background: 'rgba(255,255,255,0.08)' }} />
                      <div style={{ textAlign: 'center' }}>
                        <div style={{ fontSize: 18, fontWeight: 800, color: '#34d399', lineHeight: 1 }}>{wsDone}</div>
                        <div style={{ fontSize: 9, color: 'rgba(255,255,255,0.3)', marginTop: 2 }}>concluídos</div>
                      </div>
                      {wsOverdue > 0 && (
                        <>
                          <div style={{ width: 1, height: 24, background: 'rgba(255,255,255,0.08)' }} />
                          <div style={{ textAlign: 'center' }}>
                            <div style={{ fontSize: 18, fontWeight: 800, color: '#f87171', lineHeight: 1 }}>{wsOverdue}</div>
                            <div style={{ fontSize: 9, color: 'rgba(255,255,255,0.3)', marginTop: 2 }}>atrasados</div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                  <div style={{ borderTop: '1px solid rgba(255,255,255,0.05)', padding: '14px 26px', display: 'flex', gap: 10 }}>
                    {wsBoards.map(board => {
                      const boardCards = cards.filter(c => c.board_id === board.id);
                      const boardDone = boardCards.filter(c => c.column_name === 'done').length;
                      const boardPct = boardCards.length > 0 ? Math.round(boardDone / boardCards.length * 100) : 0;
                      return (
                        <div key={board.id} onClick={() => onSelectBoard(board, ws)} style={{ padding: '12px 16px', background: 'rgba(255,255,255,0.05)', borderRadius: 10, border: '1px solid rgba(255,255,255,0.07)', cursor: 'pointer', transition: 'all 0.2s', minWidth: 170, borderLeft: `3px solid ${wsColor}` }}
                          onMouseEnter={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.1)'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
                          onMouseLeave={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.05)'; e.currentTarget.style.transform = 'none'; }}>
                          <div style={{ fontSize: 12, fontWeight: 700, color: 'rgba(255,255,255,0.85)', marginBottom: 4 }}>{board.name}</div>
                          <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.3)', marginBottom: 8 }}>{boardCards.length} cards</div>
                          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <div style={{ flex: 1, height: 3, background: 'rgba(255,255,255,0.08)', borderRadius: 2, overflow: 'hidden' }}>
                              <div style={{ height: '100%', background: wsColor, width: `${boardPct}%`, borderRadius: 2 }} />
                            </div>
                            <span style={{ fontSize: 10, color: wsColor, fontWeight: 700 }}>{boardPct}%</span>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}